export const iconFontAwesomePunctuationSymbolsLessThan = (
	<i className="fa-solid fa-less-than"></i>
);
